import * as React from 'react';
import { Switch } from 'ui/common/switch/switch';
import { TranslationsToggleProps } from '../types';

import styles from './translations-toggle.scss';

export const TranslationsToggle: React.FC<TranslationsToggleProps> = (props: TranslationsToggleProps) => {

  const { isToggled, switchTranslationsToggleLabel } = props;

  return (
    <div className={styles.translationsToggleContainer}>
      <div>
        <Switch
          className={styles.label}
          label={switchTranslationsToggleLabel}
          key="show_translations"
          onChange={props.onChange}
          checked={isToggled}
        />
      </div>
    </div>
  );
};
